module.exports = __webpack_public_path__ + "static/media/corporate-1-slider-slide-2.47957f4b.jpg";